import React from "react"
import { GridItem } from "@chakra-ui/react"
import Link from "@components/Link"

type Props = {
  item: any
  handleTrackingClick: () => void
}

const InstagramCard: React.FC<Props> = ({ item, handleTrackingClick }) => {
  return (
    <GridItem as="article">
      <Link title={item?.title} to={item?.link?.url} onClick={handleTrackingClick}>
        {item?.image?.src && <img src={item?.image?.src} width={300} />}
      </Link>
    </GridItem>
  )
}

export default React.memo(InstagramCard)
